export const SET_GRID_SORTING = 'petdata/SET_GRID_SORTING';
export const SET_LABEL_INDEX = 'petdata/SET_LABEL_INDEX';

export const SELECT_LABEL = 'petdata/SELECT_LABEL';

export const GET_LABEL_PET_LIST = 'petdata/GET_LABEL_PET_LIST';
export const PET_LABEL_LIST_RECEIVED = 'petdata/PET_LABEL_LIST_RECEIVED';
export const PET_LABEL_LIST_RELOAD = 'petdata/PET_LABEL_LIST_RELOAD';
export const PET_LABEL_PRICE_UPDATE = 'petdata/PET_LABEL_PRICE_UPDATE';
export const PET_TYPES_ADDED = 'petdata/labels/PET_TYPES_ADDED';

export const TOGGLE_SELECTED_PET_TYPE = 'petdata/labels/TOGGLE_SELECTED_PET_TYPE';

export const LABELS_SEARCH_PHRASE = 'petdata/LABELS_SEARCH_PHRASE';
export const FILTER_PET_LABELS = 'petdata/FILTER_PET_LABELS';

export const CLEAR_SEARCH_RESULTS = 'petdata/labels/CLEAR_SEARCH_RESULTS';

export const GET_PET_LABEL = 'petdata/GET_PET_LABEL';
export const PET_LABEL_RECEIVED = 'petdata/PET_LABEL_RECEIVED';
export const SELECT_PET_LABEL = 'petdata/SELECT_PET_LABEL';
export const DESELECT_PET_LABEL = 'petdata/DESELECT_PET_LABEL';
export const CLEAR_ACTIVE_LABEL = 'petdata/CLEAR_ACTIVE_LABEL';

export const GET_LABEL_DEFINITIONS = 'petdata/GET_LABEL_DEFINITIONS';
export const LABEL_DEFINITIONS_RECEIVED = 'petdata/LABEL_DEFINITIONS_RECEIVED';

export const SELECT_LABEL_SIZE = 'petdata/SELECT_LABEL_SIZE';

export const SAVE_LABEL_TO_SHEET = 'petdata/SAVE_LABEL_TO_SHEET';
export const DELETE_LABEL_FROM_SHEET = 'petdata/DELETE_LABEL_FROM_SHEET';

export const CLEAR_LABEL_SHEET = 'petdata/CLEAR_LABEL_SHEET';

export const TOGGLE_PLU_ACTIVE = 'petdata/TOGGLE_PLU_ACTIVE';

export const EDIT_EXISTING_LABEL = 'petdata/EDIT_EXISTING_LABEL';

export const GET_CUSTOM_DEFINITIONS = 'petdata/GET_CUSTOM_DEFINITIONS';
export const CUSTOM_DEFINITIONS_RECEIVED = 'petdata/CUSTOM_DEFINITIONS_RECEIVED';
export const SELECT_CUSTOM_LABEL = 'petdata/SELECT_CUSTOM_LABEL';

export const GET_ARTICLE_LIST = 'petdata/GET_ARTICLE_LIST';
export const ARTICLE_LIST_RECEIVED = 'petdata/ARTICLE_LIST_RECEIVED';
export const UPDATE_LABEL_ARTICLE = 'petdata/UPDATE_LABEL_ARTICLE';
export const SORT_ARTICLE_COLUMN = 'petdata/SORT_ARTICLE_COLUMN';
export const CLEAR_ARTICLE_FILTERS = 'petdata/CLEAR_ARTICLE_FILTERS';
export const ADD_ARTICLE_MAPPING = 'petdata/ADD_ARTICLE_MAPPING';
export const DELETE_ARTICLE_MAPPING = 'petdata/DELETE_ARTICLE_MAPPING';

export const UPLOAD_EXCEL_MAPPINGS = 'petdata/UPLOAD_EXCEL_MAPPINGS';
export const UPLOAD_MAPPINGS_SUCCESS = 'petdata/UPLOAD_MAPPINGS_SUCCESS';

export const UPDATE_LABEL_STYLES = 'petdata/UPDATE_LABEL_STYLES';
export const UPDATE_LABEL_LOGOS = 'petdata/UPDATE_LABEL_LOGOS';
export const UPDATE_LABEL_OFFSET = 'petdata/UPDATE_LABEL_OFFSET';

export const CALIBRATION_PDF_LINK = 'petdata/CALIBRATION_PDF_LINK';

export const SHOW_ERROR_MODAL = 'petdata/SHOW_ERROR_MODAL';
export const SHOW_LABEL_MODAL = 'petdata/SHOW_LABEL_MODAL';
export const HIDE_LABEL_MODAL = 'petdata/HIDE_LABEL_MODAL';

export const ENABLE_LABEL_ADD = 'petdata/ENABLE_LABEL_ADD';
export const DISABLE_LABEL_ADD = 'petdata/DISABLE_LABEL_ADD';
export const SELECT_NEXT_LABEL = 'petdata/SELECT_NEXT_LABEL';

export const ADD_ARTICLE_FILTER = 'petdata/ADD_ARTICLE_FILTER';


/** WEBPACK FOOTER **
 ** ./src/modules/labels/actionTypes.js
 **/